/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Form, Button, Spin, message } from "antd";
import axios from "axios";

import FormComponent from "../../../components/FormComponent";
import { BasicDetails } from "./BasicDetails";
import { AddressDetails } from "./AddressDetails";
import {
  patchOnboardForm,
  patchOnboardFormClear,
} from "../../../actionsMethods/masterMethods";

import { APIs } from "../../../utils/worker";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

function CpDetails({
  screen,
  cpPirview,
  handlePrivew,
  check,
  cpResponse,
  callBack,
  loadingoutSide,
}) {
  const [motherHubId, setMotherHubId] = useState("");
  const [loading, setLoading] = useState(false);
  const [continueDisable, setContinueDisable] = useState(false);
  const [disableInputField, setDisableInputField] = useState({});
  const navigate = useNavigate();
  const history = useLocation();
  const dispatch = useDispatch();

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  useEffect(() => {
    if (result) {
      screen(1);
      dispatch(patchOnboardFormClear());
    } else if (!fetching && error) {
      message.error(error?.message);
    }
  }, [fetching]);

  let cpInitialValues = {
    CPname: cpResponse?.premiseDto?.premiseName,
    CPtype: cpResponse?.premiseDto?.cpType,
    parentId: cpResponse?.premiseDto?.parentId,
    RateCardType: cpResponse?.premiseDto?.rateCardType,
    AddressLine1: cpResponse?.premiseDto?.addressLine1,
    AddressLine2: cpResponse?.premiseDto?.addressLine2,
    PINcode: cpResponse?.premiseDto?.pincode,
    City: cpResponse?.premiseDto?.city,
    StateName: cpResponse?.premiseDto?.state,
    StateCode: cpResponse?.premiseDto?.stateCode,
    Longitude: cpResponse?.premiseDto?.longitude,
    Latitude: cpResponse?.premiseDto?.latitude,
    hubZoon: cpResponse?.premiseDto?.zone,
    billingCycle: cpResponse?.premiseDto?.billingCycle,
    MotherHubName: cpResponse?.premiseDto?.parentPremiseName,
    mineHubConnected: cpResponse?.premiseDto?.mineHubConnected,
    miniHub: cpResponse?.premiseDto?.mineHubName,
    branchPresent: cpResponse?.premiseSubBranch?.length > 0 ? true : false,
    numberOfBranch: cpResponse?.premiseSubBranch?.length,
  };

  useEffect(() => {
    if (cpResponse) {
      setLoading(true);
      form.setFieldsValue(cpInitialValues);
      const cpBooleanValues = {};
      for (const key in cpInitialValues) {
        cpBooleanValues[key] = !!cpInitialValues[key];
      }
      setDisableInputField(cpBooleanValues);
      setLoading(false);
    }
  }, [cpResponse]);

  const continueCallBack = (val) => {
    setContinueDisable(val);
  };

  function handlerHubId(val) {
    return setMotherHubId(val);
  }

  useEffect(() => {
    form.resetFields();
  }, [check]);

  const onSubmitFormData = (values) => {
    console.log(values);
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    const headers = {
      userName: userData?.userName,
    };

    let temp = [];
    let i = 0;
    Object.keys(values).forEach((e) => {
      let res = e.slice(-1).match(/\d+/g);
      if (res !== null && e === `PINcode${res[0]}`) {
        let ival = ++i;
        let branchNumber = ival.toString();
        let addressLine1 = `AddressLine1${res[0]}`;
        let addressLine2 = `AddressLine2${res[0]}`;
        let pincode = `PINcode${res[0]}`;
        let city = `City${res[0]}`;
        let state = `StateName${res[0]}`;
        let stateCode = `StateCode${res[0]}`;
        temp.push({
          branchNumber,
          addressLine1: values[addressLine1],
          addressLine2: values[addressLine2],
          pincode: +values[pincode],
          city: values[city],
          state: values[state],
          stateCode: values[stateCode],
        });
      }
    });

    let payload = {
      premiseDto: {
        premiseName: values?.CPname,
        cpType: values?.CPtype,
        parentId: +motherHubId?.key,
        rateCardType: values?.RateCardType,
        addressLine1: values?.AddressLine1,
        addressLine2: values?.AddressLine2,
        pincode: +values?.PINcode,
        city: values?.City,
        state: values?.StateName,
        stateCode: values?.StateCode,
        longitude: values?.Longitude,
        latitude: values?.Latitude,
        zone: values?.hubZoon,
        billingCycle: values?.billingCycle,
        parentPremiseName: values?.MotherHubName,
        // hubType: "Mother Hub",
        mineHubConnected:
          values?.mineHubConnected == null
            ? false
            : JSON.stringify(values?.mineHubConnected),
        mineHubName:
          values?.mineHubConnected == null || false ? null : values?.miniHub,
      },
      premiseSubBranch: temp,
    };

    dispatch(
      patchOnboardForm(payload, userData?.userName, cpResponse.premiseId)
    );
    // console.log(payload);
  };

  const formProps = {
    name: "CpDetails",
    className: "register-form",
    initialValues: {
      //   layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };
  const formLayout = "vertical";

  const [form] = Form.useForm();
  const isInputDisabled = !!form.getFieldValue(); // Replace 'yourFieldName' with the actual field name
  return (
    <Spin spinning={loading || fetching || loadingoutSide}>
      <div className="form-contener">
        <div className="form-contener-inner">
          <div className="form-contener-priview">
            <FormComponent
              formProps={formProps}
              formLayout={formLayout}
              form={form}
              // initialValues={initial}
            >
              <BasicDetails
                setLoading={setLoading}
                form={form}
                handlerHubId={handlerHubId}
                cpResponse={cpResponse}
                disableInputField={disableInputField}
              />
              <AddressDetails
                form={form}
                continueCallBack={continueCallBack}
                cpResponse={cpResponse}
                disableInputField={disableInputField}
              />
            </FormComponent>
          </div>
        </div>

        <div className="button-container1">
          <div className="steps-action">
            <Button
              htmlType="submit"
              className="next-button"
              form="CpDetails"
              key="submit"
              disabled={continueDisable}
            >
              {"CONTINUE"}
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default CpDetails;
